export default {
    login: ['/log_reg/login', 'post'],
    logout: ['/log_reg/logout', 'post'],
    register: ['/log_reg/register', 'post']
}